import ApiRequest from "../util/ApiRequest";
import GlobalData from "../util/GlobalData";

export default class ContactForm {
    create = async (body) => {
        return await ApiRequest.set(`/v1/contact_forms`, "POST", body);
    }
}
